import React from 'react';
import { useState, useEffect } from 'react';
import introLogo from '../thiru.png'
import Particles from 'react-particles-js';

import { db } from './firebase';
import { collection, getDocs, updateDoc ,doc} from 'firebase/firestore';


const Hero = (props) => {

	const data = props.portfolioData;

	const [resume,setUsers] = useState([]);
  	const usersCollectionRef = collection(db,"resume");
	const updateUser = async(id,likes)=>{
		const userDoc = doc(db,"resume",id);//for selected user
		const newFields = {likes:likes+1};
		await updateDoc(userDoc,newFields);
	  }
  	useEffect(()=>{
    	const getUsers = async () => {
      	const data = await getDocs(usersCollectionRef);
      	console.log(data);
    	setUsers(data.docs.map((doc) => ({...doc.data(), id: doc.id })));
    };
    getUsers();
  	}, [])	

	return (
		<section className="site-intro site-intro--with-clipmask" >
				<Particles
					className="site-intro__canvas"
					params={{
        particles: {
			move: {
	            random: true,
	            speed: 1,
	            direction: "top",
	            out_mode: "out"
	        },
          number: { value: 50, density: { enable: true, value_area: 400 } },
          shape: { type: 'circle', stroke: { width: 1, color: 'voilet' } },
          size: { value: 8, random: true, anim: { enable: true, speed: 8, size_min: 0.1, sync: true } },
          opacity: { value: 1, random: true, anim: { enable: true, speed: 1, opacity_min: 0.1, sync: true } }
	    }
      }}
				/>
				
			<div className="container">
				<div className="site-intro__wrapper">
					<div className="site-intro__main">
						<div className="site-intro__intro">
							<h2 className="site-intro__name"> {data.name} </h2>
							<h2 className="site-intro__heading"> I'm a {data.role} </h2>
							<h1 className="site-intro__primary"> {data.intro} </h1>
							<div className="site-intro__action">
							{resume.map((res)=>{
        					return (
          						<div>
            						{" "}
            						<a
										className="btn btn-outline-white btn-radius btn-lg"
										href={res.link}
										target="_blank"
										rel="noopener noreferrer">
									Resume
	          						</a>
          						</div>
							);	
       						})}
								
								
									
							</div>
						</div>
					</div>
					<div className="site-intro__logo-wrapper">
						<img src={introLogo} alt="" className="site-intro__logo" />
					</div>

				</div>
			</div>
		</section>
	)
}

export default Hero;